
import Api from '@/utils/api';
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Cell from 'vux/src/components/cell/index.vue'

export default {
data() {
return {
code: ''
}
},
components: {
XInput,
Group,
XButton,
Cell
},
mounted() {
if (!this.$store.state.userInfo.mobileNumber) {
this.$router.push({
name: 'bindMobileNumber',
params: {
ref: 'coupon'
}
})
this.$vux.toast.text('领取兑换码需要先绑定你的手机号')
}
},
methods: {
addCoupon() {
if(!this.code){
this.$vux.toast.text('请输入兑换码')
return
}
const that = this
Api.addCoupon({
code: this.code
})
.then(res => {
this.$vux.confirm.show({
title: '领取成功',
content: '获得商品[ <img src="'+process.env.UPLOAD_DOMAIN + res.data.product.thumbnail + '?x-oss-process=image/resize,w_20"></img>'+res.data.product.title+' ]兑换券一张, <br>是否立即使用？',
onConfirm () {
that.$router.push({
name: 'recommend',
query: {
coupon: JSON.stringify(res.data)
}
})
}
})
})
.catch(e => {
if(e && e.response && e.response.data) {
if (e.response.data.message == 'The coupon has been owned already!') {
this.$vux.alert.show({
title: '失败',
content: '兑换码已经被领取'
})
return
} else if (e.response.data.message == 'The coupon has been used already!') {
this.$vux.alert.show({
title: '失败',
content: '兑换码已经被使用'
})
return
}
}
this.$vux.alert.show({
title: '失败',
content: '兑换码不可用'
})
})
}
}
}



// WEBPACK FOOTER //
// ./src/components/UserCenter/addCoupon/addCoupon.vue